<template>
  <div class="header-top">
    <div class="header-top-wrapper">
      <!-- Logo -->
      <div class="logo">
        <router-link to="/" class="logo">
          <img
            v-if="theme == 'light'"
            src="@/assets/img/logo/gamek-2.png"
            alt="logo"
          />
          <img
            v-if="theme == 'dark'"
            src="@/assets/img/logo/gamek.png"
            alt="logo"
          />
        </router-link>
      </div>
      <!-- Middle Referral Section -->
      <div class="middle-referral">
        <ul>
          <li>
            <router-link to="/" class="home-icon">
              <img src="@/assets/img/header/Home.png" alt="home" />
            </router-link>
          </li>
          <li>
            <router-link to="/games">{{ $t('Games') }}</router-link>
          </li>
          <li>
            <router-link to="/leaderboard">{{ $t('Leaderboard') }}</router-link>
          </li>
          <li>
            <label class="theme-switch-container">
              <span class="theme-switch-label">
                <span class="light-label d-flex align-items-center" v-if="theme == 'light'">
                  <i class="fas fa-sun"></i>
                </span>
                <span class="dark-label text-white d-flex align-items-center" v-if="theme == 'dark'">
                  <i class="fas fa-moon"></i>
                </span>
              </span>
              <input
                type="checkbox"
                class="theme-switcher"
                @change="toggleTheme"
              />
              <div class="slider round"></div>
            </label>
          </li>
          <li>
            <a href="#" class="search-icon Click-here">
              <img src="@/assets/img/header/search.png" alt="search-img" />
            </a>
          </li>
          <li class="form-wrapper">
            <form action="/search" method="get" >
              <input
                type="search"
                name="query"
                :placeholder="$t('Search...')"
                v-model="query"
                @input="fetchSuggestions"
              />
              <div class="suggestions-container" v-if="autoCompleteList.length > 0">
                <ul class="suggestions-ul">
                  <li v-for="item in autoCompleteList" :key="item.id" 
                  @click="selectSuggestion(item)">
                    {{ item.title }}
                  </li>
                </ul>
              </div>
              <div class="search">
                <img src="@/assets/img/header/search.png" alt="search-img" />
              </div>
            </form>
          </li>
        </ul>
      </div>
      <!-- Social Icons and Login/Sign Up Buttons -->
      <ul class="header-top-social d-flex align-items-center">
        <!-- <li>
          <a href="#" class="icon">
            <img src="@/assets/img/header/tele.png" alt="img" />
          </a>
        </li>
        <li>
          <a href="#" class="icon">
            <img src="@/assets/img/header/Discordicon.png" alt="img" />
          </a>
        </li> -->
        <li class="btn-top-group d-flex align-items-center">
          <a href="#" class="icon" @click="shareWebsite">
            <img src="@/assets/img/share/icons8-whatsapp-500.png" alt="img" />
          </a>
        </li>
        <li class="btn-top-group d-flex align-items-center" v-if="!isLoggedIn">
          <a class="cmn--btn" href="#" @click="openLogin">
            <span>{{ $t("Login") }}</span>
          </a>
        </li>
        <li class="btn-top-group d-flex align-items-center" v-else>
          <a class="cmn--btn" href="#" @click="onLogout">
            <span>{{ $t("Logout") }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { useSearchStore } from "@/store/search";
import { mapActions, mapState } from "pinia";
import { useLanguageStore } from "@/store/language";
import { useAuthStore } from "@/store/auth";
import { useHomeStore } from "@/store/home";
import helpers from "@/helpers";

export default {
  name: "HeaderTop",
  inject: ["isRtlLayout"],
  computed: {
    ...mapState(useAuthStore, ["isLoggedIn", "userInfo"]),
    ...mapState(useHomeStore, ["theme"]),
    ...mapState(useSearchStore, ["query", "autoCompleteList"]),
  },
  methods: {
    ...mapActions(useSearchStore, ["autocompleteSearch"]),
    ...mapActions(useLanguageStore, ["setLocale"]),
    ...mapActions(useAuthStore, ["logout", "unsubscribe", "openPaymentPage"]),
    ...mapActions(useHomeStore, ["toggleTheme", "loadTheme"]),
    async fetchSearch() {
      console.log("this.query", this.query)
      if (this.query == "") return;

      this.$router.push(`/search?query=${encodeURIComponent(this.query)}`);
    },
    openSubscription() {
      localStorage.setItem("redirectUrl", this.$route.fullPath);

      let config = helpers.getConfig();
      if(config.subscription_type == "card"){
        if(!this.isLoggedIn){
          this.openLogin();
        } else {
          this.openPaymentPage()
        }
      } else {
        window.location.href = config.landing_page_url;
      }
    },
    openLogin() {
      localStorage.setItem("redirectUrl", this.$route.fullPath);
      this.$router.push({ name: "login" });
    },
    async onLogout() {
      await this.logout();
      this.$router.push("/");
    },
    shareWebsite() {
      const url = window.location.origin;
      const title = this.$t("Try this gaming website, it's a wonderful");
      window.open(
        `https://api.whatsapp.com/send?text=${title} - ${encodeURIComponent(
          url
        )}`,
        "_blank"
      );
    },
    fetchSuggestions(event) {
      const search = event.target.value.trim();

      if (search.length >= 3) {

        this.autocompleteSearch(search);
      } else {
        this.autoCompleteList = [];
      }
    },
    selectSuggestion(suggestion) {
      this.query = suggestion.title.trim();
      this.autoCompleteList = [];
      this.$router.push(`/search?query=${encodeURIComponent(suggestion.title)}`);
    },
  },
  mounted() {
    this.loadTheme();
  },
};
</script>

<style>
.body-middle {
  padding-top: 136px !important;
}
.left-site-menu {
  top: 136px !important;
}

@media screen and (max-width: 575px) {
  .body-middle {
    padding-top: 90px !important;
  }
  .left-site-menu {
    top: 90px !important;
  }
}

.theme-switch-container {
  /* position: absolute;
    top: 1rem;
    right: 1rem; */
  display: flex;
  align-items: center;
  align-self: center;
}

.theme-switch-label {
  margin-right: 10px;
  font-size: 16px;
  color: #000;
  /* Light theme color */
}

.theme-switcher {
  height: 0;
  width: 0;
  visibility: hidden;
}

.slider {
  cursor: pointer;
  height: 20px;
  width: 40px;
  background: #ccc;
  display: inline-block;
  border-radius: 34px;
  position: relative;
}

.slider::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  transition: 0.3s;
  background: #fff;
}

.theme-switcher:checked + .slider {
  background: #66bb6a;
}

.theme-switcher:checked + .slider::after {
  left: calc(100% - 3px);
  transform: translateX(-100%);
}

.suggestions-container {
  position: fixed;
}

.suggestions-ul {
  display: flex; 
  flex-direction: column;
  align-items: flex-start !important;
  background-color: var(--chat-bg);
}

.suggestions-ul li {
  padding: 6px 16px;
  border-right: none !important;
  cursor: pointer;
}
.suggestions-ul li:hover {
  background-color: var(--box-two);
}
</style>
